



$(document).ready(function() {
  

  
  
  
      $('.custom-tabs').click(function() {
          
        $('.custom-tabs').removeClass('active');
        $(this).addClass('active');
        if($(this).hasClass('custom-tab-1')) {
          $('#shopify-section-template--22761804497161__section_product_qmdw4F').show();
          $('#shopify-section-template--22761804497161__section_product_4pKGg8').hide();
        } else if($(this).hasClass('custom-tab-2')) {
           $('#shopify-section-template--22761804497161__section_product_qmdw4F').hide();
          $('#shopify-section-template--22761804497161__section_product_4pKGg8').show();
        }
        
      });

    $('.custom-tab-1').click();

    
    


  

 
});















